import React from 'react';
import styles from './DEGInnerReportComponent.module.css';
// ★ 지정해주신 로고 이미지 경로
import converLogo from '../../img/gradiantbioconvergence/gradiantbio_logo.png';

function DEGInnerReportComponent({ data }) {
    if (!data) return null;

    const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

    // 데이터 추출 (백엔드에서 파싱해 넘겨주는 데이터)
    const sampleList = data.sampleList || [];
    const summaryData = data.summaryData || {};
    const images = data.images || {};
    const jobName = data.sampleName || '[Job_Name]';

    // =================================================================
    // ★ 동적 섹션(목차) 및 페이지 번호 계산 로직
    // =================================================================
    let currentSec = 1;
    const secMapping = currentSec++;      // 1. Mapping Summary
    const secMethod = currentSec++;       // 2. Analysis Information & Methodology
    const secCorrelation = currentSec++;  // 3. Sample Correlation
    const secDeg = currentSec++;          // 4. Differential Expression Analysis (DEG)
    const secGO = currentSec++;           // 5. Functional Enrichment Analysis (GO)

    let currentPage = 1;
    const pageNum_Cover = currentPage++;
    const pageNum_TOC = currentPage++;
    const pageNum_Mapping = currentPage++;
    const pageNum_Method = currentPage++;
    const pageNum_PCA = currentPage++;
    const pageNum_Scatter = currentPage++;
    const pageNum_Volcano = currentPage++;    // Volcano 단독
    const pageNum_MA = currentPage++;         // MA 단독
    const pageNum_Heatmap = currentPage++;    // Heatmap (단독)
    const pageNum_GO_Desc = currentPage++;    // GO 설명 페이지
    const pageNum_GO_BP = currentPage++;      // GO BP (UP/DOWN)
    const pageNum_GO_MF = currentPage++;      // GO MF (UP/DOWN)
    const pageNum_GO_CC = currentPage++;      // GO CC (UP/DOWN)

    const totalPages = currentPage - 1;

    // =================================================================
    // ★ 디자인 통일성을 위한 공통 인라인 스타일 정의
    // =================================================================
    const s_paraTitle = { fontSize: '16px', color: '#111827', fontWeight: 'bold', margin: '0 0 8px 0' };
    const s_secTitle = { fontSize: '16px', marginTop: '20px', marginBottom: '10px' };
    const s_subTitle = { fontSize: '14px', color: '#374151', fontWeight: 'bold', margin: '0 0 6px 0' };
    const s_desc = { fontSize: '12px', lineHeight: '1.6', margin: '0 0 15px 0', color: '#374151' };
    const s_table = { fontSize: '10.5px', marginBottom: '20px' };

    // 표지 전용 스타일
    const s_coverTh = { textAlign: 'left', padding: '4px 24px 4px 0', border: 'none', background: 'none', fontWeight: 'bold', color: '#374151', fontSize: '12px' };
    const s_coverTd = { textAlign: 'left', padding: '4px 0', border: 'none', background: 'none', color: '#4b5563', fontSize: '12px', wordBreak: 'break-all' };

    // =================================================================
    // ★ 스크롤 이동 핸들러
    // =================================================================
    const scrollToSec = (e, id) => {
        e.preventDefault();
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    };

    // =================================================================
    // ★ 공통 렌더링 함수들
    // =================================================================
    const renderTopLogo = (isCover = false) => (
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginBottom: isCover ? '0' : '10px' }}>
            <img src={converLogo} alt="Gradiant Bioconvergence Logo" style={{ height: isCover ? '45px' : '25px', objectFit: 'contain' }} />
        </div>
    );

    const renderPageHeader = (title) => (
        <div className={styles.pageHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h2 style={{ margin: 0 }}>{title}</h2>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <img src={converLogo} alt="Gradiant Bioconvergence Logo" style={{ height: '25px', objectFit: 'contain', marginBottom: '4px' }} />
                {/* 👇 lineHeight를 '1.2'로 키우고, paddingBottom: '2px'를 추가했습니다! */}
                <div className={styles.sampleId} style={{ margin: 0, lineHeight: '1.2', paddingBottom: '2px', maxWidth: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={jobName}>
                    {jobName}
                </div>
            </div>
        </div>
    );

    const renderFooter = (pageNum) => (
        <div className={styles.pageFooter} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', borderTop: '1px solid #e5e7eb', paddingTop: '15px', marginTop: 'auto' }}>
            <div style={{ textAlign: 'left' }}>
                <p style={{ margin: 0, fontSize: '10px', color: '#6b7280' }}>For Research Use Only. Not intended for diagnostic procedures.</p>
                <p style={{ margin: 0, fontSize: '10px', color: '#6b7280' }}>© Gradiant Bioconvergence. All Rights Reserved.</p>
            </div>
            <div style={{ textAlign: 'right' }}>
                <p style={{ margin: '0 0 6px 0', fontSize: '11px', fontWeight: 'bold', color: '#ef4444' }}>STRICTLY CONFIDENTIAL</p>
                <p style={{ margin: 0, fontSize: '11px', fontWeight: 'bold', color: '#374151' }}>Page {pageNum} / {totalPages}</p>
            </div>
        </div>
    );

    return (
        <div className={styles.reportWrapper}>

            {/* ==========================================
                Page 1: 표지 (Cover)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`} style={{ display: 'flex', flexDirection: 'column' }}>
                {renderTopLogo(true)}

                <div className={styles.titleSection} style={{ marginTop: '120px', flex: 1 }}>
                    <div className={styles.brandLine}></div>
                    <h1>DEG Analysis Report</h1>
                    <p className={styles.subtitle}>Differentially Expressed Genes Summary</p>

                    <div className={styles.infoBoxCover}>
                        <table className={styles.coverInfoTable}>
                            <tbody>
                                <tr>
                                    <th style={s_coverTh}>Analysis Name (Folder)</th>
                                    <td style={s_coverTd}>{jobName}</td>
                                </tr>
                                <tr>
                                    <th style={s_coverTh}>Date</th>
                                    <td style={s_coverTd}>{today}</td>
                                </tr>
                                <tr>
                                    <th style={s_coverTh}>Cancer Type</th>
                                    <td style={s_coverTd}>{summaryData.cancerType || '-'}</td>
                                </tr>
                                <tr>
                                    <th style={s_coverTh}>Application</th>
                                    <td style={s_coverTd}>RNA-Seq DEG Analysis</td>
                                </tr>
                                <tr>
                                    <th style={s_coverTh}>Comparison</th>
                                    <td style={s_coverTd}>{summaryData.comparison || '-'}</td>
                                </tr>
                                <tr>
                                    <th style={s_coverTh}>Total Genes Filtered</th>
                                    <td style={s_coverTd}>{summaryData.filteredGenes || '-'}</td>
                                </tr>
                                <tr>
                                    <th style={s_coverTh}>Total DEGs</th>
                                    <td style={{ ...s_coverTd, color: '#ef4444', fontWeight: 'bold' }}>{summaryData.degTotal || '-'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={styles.footerSection} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className={styles.footerNotice} style={{ margin: '0 0 6px 0' }}>For Research Use Only</div>
                    <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#ef4444', marginBottom: '8px' }}>STRICTLY CONFIDENTIAL</div>
                    <div style={{ fontSize: '11px', color: '#6b7280' }}>Page {pageNum_Cover} / {totalPages}</div>
                </div>
            </div>

            {/* ==========================================
                Page 2: 목차 (Table of Contents)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`} id="section-toc">
                {renderPageHeader('Table of Contents')}

                <div style={{ marginTop: '20px', padding: '0 20px' }}>
                    <ul style={{ listStyle: 'none', padding: 0, fontSize: '15px', lineHeight: '2.5', fontWeight: 'bold' }}>
                        <li><span onClick={(e) => scrollToSec(e, 'sec-mapping')} style={{ cursor: 'pointer', color: '#2563eb' }}>{secMapping}. Mapping Summary</span></li>
                        <li><span onClick={(e) => scrollToSec(e, 'sec-method')} style={{ cursor: 'pointer', color: '#2563eb' }}>{secMethod}. Analysis Information & Methodology</span></li>
                        <li><span onClick={(e) => scrollToSec(e, 'sec-correlation')} style={{ cursor: 'pointer', color: '#2563eb' }}>{secCorrelation}. Sample Correlation</span></li>
                        <li><span onClick={(e) => scrollToSec(e, 'sec-deg')} style={{ cursor: 'pointer', color: '#2563eb' }}>{secDeg}. Differential Expression Analysis (DEG)</span></li>
                        <li><span onClick={(e) => scrollToSec(e, 'sec-go')} style={{ cursor: 'pointer', color: '#2563eb' }}>{secGO}. Functional Enrichment Analysis (GO)</span></li>
                    </ul>
                </div>

                {renderFooter(pageNum_TOC)}
            </div>

            {/* ==========================================
                Page 3: Mapping Summary
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`} id="sec-mapping">
                {renderPageHeader(`${secMapping}. Mapping Summary`)}

                <p className={styles.description} style={{ ...s_desc, marginBottom: '20px' }}>
                    The key mapping results and overall transcriptome expression metrics of the RNA NGS data analysis. The table displays the Total Read, representing the total volume of generated data, the Mapped Read, indicating the number of reads successfully aligned to the reference genome, and its corresponding percentage (Mapping Rate, %). Additionally, it provides the total number of genes with detected expression in the target sample (Expressed Gene).
                </p>

                <h3 className={styles.sectionTitle} style={{ ...s_secTitle, marginTop: '0', marginBottom: '8px' }}>Mapping Summary</h3>
                <table className={styles.dataTable} style={s_table}>
                    <thead>
                        <tr>
                            <th>Sample Name</th>
                            <th>Total Read</th>
                            <th>Mapped Read</th>
                            <th>Mapping Rate (%)</th>
                            <th>Expressed Gene</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sampleList.length > 0 ? (
                            sampleList.map((sample, idx) => (
                                <tr key={idx}>
                                    <td style={{ fontWeight: 'bold' }}>{sample.sampleName}</td>
                                    <td>{sample.totalRead !== '-' ? Number(sample.totalRead).toLocaleString() : '-'}</td>
                                    <td>{sample.mappedRead !== '-' ? Number(sample.mappedRead).toLocaleString() : '-'}</td>
                                    <td>{sample.percent}</td>
                                    <td>{sample.expressedGene !== '-' ? Number(sample.expressedGene).toLocaleString() : '-'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>No sample mapping data available.</td></tr>
                        )}
                    </tbody>
                </table>

                <h3 className={styles.sectionTitle} style={s_secTitle}>Column Description</h3>
                <table className={styles.dataTable} style={s_table}>
                    <thead>
                        <tr>
                            <th style={{ width: '25%' }}>Column</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody style={{ textAlign: 'left' }}>
                        <tr><td style={{ textAlign: 'center' }}><strong>Total Read</strong></td><td>The total number of reads generated from the sequencing process.</td></tr>
                        <tr><td style={{ textAlign: 'center' }}><strong>Mapped Read</strong></td><td>The number of reads that successfully aligned to the reference genome.</td></tr>
                        <tr><td style={{ textAlign: 'center' }}><strong>Mapping Rate (%)</strong></td><td>The ratio of mapped reads to total reads, indicating alignment efficiency.</td></tr>
                        <tr><td style={{ textAlign: 'center' }}><strong>Expressed gene</strong></td><td>The total number of Expressed genes detected in the sample.</td></tr>
                    </tbody>
                </table>

                {renderFooter(pageNum_Mapping)}
            </div>

            {/* ==========================================
                Page 4: Analysis Information & Methodology
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`} id="sec-method">
                {renderPageHeader(`${secMethod}. Analysis Information & Methodology`)}

                <h3 style={{ ...s_paraTitle, marginTop: '0', marginBottom: '8px' }}>Sample information</h3>
                <p style={s_desc}>Conditions (normal or tumor) utilized for the analysis are defined in the table below:</p>

                <table className={styles.dataTable} style={{ ...s_table, width: '60%', margin: '0 auto 20px auto' }}>
                    <thead>
                        <tr>
                            <th style={{ width: '60%' }}>Sample Name</th>
                            <th style={{ width: '40%' }}>Condition</th>
                        </tr>
                    </thead>
                    <tbody style={{ textAlign: 'center' }}>
                        {sampleList.length > 0 ? (
                            sampleList.map((sample, idx) => (
                                <tr key={idx}>
                                    <td style={{ fontWeight: 'bold' }}>{sample.sampleName}</td>
                                    <td style={{ color: sample.condition?.toLowerCase() === 'tumor' ? '#ef4444' : '#3b82f6', fontWeight: 'bold' }}>
                                        {sample.condition}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="2">No condition data available.</td></tr>
                        )}
                    </tbody>
                </table>

                <h4 style={{ ...s_subTitle, marginTop: '25px' }}>Methodology</h4>
                <ul style={{ ...s_desc, paddingLeft: '20px', listStyleType: 'disc', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <li>
                        <strong>Expression quantification:</strong> Gene expression was quantified using RSEM, and the resulting maximum likelihood abundance estimates (expected_count) were extracted and rounded to integers to construct the raw count matrix for the analysis.
                    </li>
                    <li>
                        <strong>Gene filtering:</strong> To reduce the multiple-testing burden and remove uninformative transcripts, lowly expressed genes were filtered out prior to statistical modeling. Specifically, genes failing to meet a total expected count &gt;=10 across all biological replicates within at least one condition group were excluded.
                    </li>
                    <li>
                        <strong>Normalization & statistical testing:</strong> The filtered count matrix was processed using the DESeq2 package. Size factors were calculated using the median-of-ratios method to normalize for library depth variations, and differential expression was evaluated by fitting the normalized counts to a negative binomial generalized linear model, followed by a Wald test for statistical significance.
                    </li>
                    <li>
                        <strong>Variance stabilization:</strong> For distance-based metrics and high-dimensional clustering visualizations (e.g., PCA, scatter plot, and heatmaps), the normalized counts were subjected to a regularized-logarithm (rlog, blind=FALSE) transformation using DESeq2 to stabilize variance across the mean.
                    </li>
                    <li>
                        <strong>Functional annotation:</strong> Statistically significant Differentially Expressed Genes (DEGs) were extracted and subjected to Gene Ontology (GO) over-representation analysis using clusterProfiler to identify enriched biological networks.
                    </li>
                </ul>

                {renderFooter(pageNum_Method)}
            </div>

            {/* ==========================================
                Page 5: Sample Correlation (PCA)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`} id="sec-correlation">
                {renderPageHeader(`${secCorrelation}. Sample Correlation`)}

                <p style={s_desc}>
                    To ensure the integrity of the statistical inference, PCA and sample correlation was performed using rlog-transformed expression values.
                </p>

                <h4 style={s_subTitle}>Principal Component Analysis (PCA)</h4>
                <p style={{ ...s_desc, marginBottom: '8px' }}>
                    PCA reduces high-dimensional transcriptomic data into orthogonal principal components (PC1, PC2) that capture the maximum variance within the dataset. Main objective of this analysis is to assess overall distance between samples from same condition (i.e. normal) and detect non-biological technical variances (batch effects) or anomalous outlier samples.
                </p>
                <p style={s_desc}>
                    Biological replicates should cluster tightly together. The distance between points corresponds to the degree of transcriptomic variance; a distinct spatial separation between groups (e.g., Normal vs. Tumor) along PC1 confirms that the primary experimental condition drives the observed transcriptional changes.
                </p>

                <div style={{ width: '100%', height: '450px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box' }}>
                    {images.PCA ? (
                        <img src={images.PCA} alt="PCA Plot" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[PCA Image Not Found]</span>
                    )}
                </div>

                {renderFooter(pageNum_PCA)}
            </div>

            {/* ==========================================
                Page 6: Sample Correlation (Scatter Matrix)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`}>
                {renderPageHeader(`${secCorrelation}. Sample Correlation`)}

                <h4 style={s_subTitle}>Reproducibility between samples</h4>
                <p style={s_desc}>
                    The sample correlation matrix calculates pairwise Pearson correlation coefficients (<em>r</em>) using rlog-stabilized values to mathematically quantify reproducibility among biological replicates. This analysis verifies experimental uniformity and the absence of technical noise within identical condition groups. Correlation coefficients approaching 1.0 signify high data integrity and robust experimental consistency.
                </p>

                <div style={{ width: '100%', height: '600px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box' }}>
                    {images.ScatterMatrix ? (
                        <img src={images.ScatterMatrix} alt="Sample Scatter Matrix" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[Scatter Matrix Image Not Found]</span>
                    )}
                </div>

                {renderFooter(pageNum_Scatter)}
            </div>

            {/* ==========================================
                Page 7: DEG Results (Volcano Plot 단독)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`} id="sec-deg">
                {renderPageHeader(`${secDeg}. Differential Expression Analysis (DEG)`)}

                <p style={s_desc}>
                    The DESeq2 framework evaluates differential expression by fitting raw counts to a negative binomial distribution model, subsequently applying a Wald test to determine the statistical significance of expression shifts between the conditions.
                </p>

                <h4 style={s_subTitle}>Result file description</h4>
                <ul style={{ ...s_desc, paddingLeft: '20px', listStyleType: 'decimal', marginBottom: '20px' }}>
                    <li style={{ marginBottom: '6px' }}>
                        <strong>{jobName}_DEG_results.tsv</strong>: Contains the complete DESeq2 statistical output. Key columns include baseMean (average normalized expression), log2FoldChange (magnitude of effect size), pvalue (raw statistical significance), and padj (BH-adjusted p-value/FDR).
                    </li>
                    <li>
                        <strong>{jobName}_counts.tsv</strong>: Contains the rlog transformed counts (used for PCA, scatter plot and heatmap), and raw expected counts from RSEM.
                    </li>
                </ul>

                {/* Volcano Plot */}
                <h4 style={s_subTitle}>Volcano plot</h4>
                <p style={s_desc}>
                    The X-axis represents the magnitude of change (log2 of fold change between tumor and normal conditions), while the Y-axis represents statistical significance (-log10 of raw p-value).
                </p>
                <div style={{ width: '100%', height: '600px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box', marginBottom: '20px' }}>
                    {images.Volcano ? (
                        <img src={images.Volcano} alt="Volcano Plot" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[Volcano Plot Image Not Found]</span>
                    )}
                </div>

                {renderFooter(pageNum_Volcano)}
            </div>

            {/* ==========================================
                Page 8: DEG Results (MA Plot 단독)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`}>
                {renderPageHeader(`${secDeg}. Differential Expression Analysis (DEG)`)}

                {/* MA Plot */}
                <h4 style={s_subTitle}>MA plot</h4>
                <p style={s_desc}>
                    The X-axis represents the baseline expression magnitude (log2 of average normalized expression), and the Y-axis represents the magnitude of change (log2 of fold change between tumor and normal conditions).
                </p>
                <div style={{ width: '100%', height: '550px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box' }}>
                    {images.MA ? (
                        <img src={images.MA} alt="MA Plot" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[MA Plot Image Not Found]</span>
                    )}
                </div>

                {renderFooter(pageNum_MA)}
            </div>

            {/* ==========================================
                Page 9: Heatmap (단독 크게 표시)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`}>
                {renderPageHeader(`${secDeg}. Differential Expression Analysis (DEG)`)}

                <h4 style={s_subTitle}>Heatmap</h4>
                <p style={s_desc}>
                    A heatmap of the top DEGs is generated using gene-wise Z-scores of rlog-transformed values to center each gene's expression to a mean of zero and scale it by its standard deviation. Z-score ensures that inherently high-abundance genes do not visually drown out critical shifts in lower-abundance regulatory genes. Then genes and samples are clustered utilizing Euclidean distance metrics coupled with Complete linkage.
                </p>

                <div style={{ width: '100%', height: '750px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box' }}>
                    {images.Heatmap ? (
                        <img src={images.Heatmap} alt="Heatmap Plot" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[Heatmap Image Not Found]</span>
                    )}
                </div>

                {renderFooter(pageNum_Heatmap)}
            </div>

            {/* ==========================================
                Page 10: GO Analysis (Description Table)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`} id="sec-go">
                {renderPageHeader(`${secGO}. Functional Enrichment Analysis (GO)`)}

                <p style={s_desc}>
                    To elucidate the broader biological significance of the identified Differentially Expressed Genes (DEGs), functional enrichment analysis was done by using the clusterProfiler. This analysis employs a hypergeometric test to identify over-represented functional categories from the Gene Ontology database (Biological Process, Molecular Function, Cellular Component).
                </p>

                <p style={{ ...s_desc, marginBottom: '20px' }}>
                    Functional enrichment outputs are systematically named as <strong>GO_[Ontology]_[Direction].[Extension]</strong> (e.g., GO_BP_UP.csv, GO_MF_DOWN_dotplot.png). This convention categorizes the statistical tables (.csv) and plots (_dotplot.png) by their specific GO domain (Biological Process, Molecular Function, Cellular Component) and expression direction (UP or DOWN-regulated DEGs).
                </p>

                <h3 className={styles.sectionTitle} style={{ ...s_secTitle, marginTop: '0', marginBottom: '8px' }}>Result file description</h3>
                <table className={styles.dataTable} style={{ ...s_table, fontSize: '9px', marginBottom: '0', tableLayout: 'fixed', width: '100%' }}>
                    <thead>
                        <tr>
                            <th style={{ width: '22%', padding: '4px 6px' }}>Column</th>
                            <th style={{ width: '78%', padding: '4px 6px' }}>Description</th>
                        </tr>
                    </thead>
                    <tbody style={{ lineHeight: '1.3' }}>
                        {[
                            { col: 'ID', desc: 'Unique identifier of Gene Ontology (GO) database' },
                            { col: 'Description', desc: 'The actual biological name of the pathway, cellular structure, or molecular function' },
                            { col: 'GeneRatio', desc: 'The fraction of Differentially Expressed Genes (DEGs) annotated to a pathway displayed in an "A/B" format, where "A" is the number of DEGs involved in the pathway and "B" is the total number of UP or DOWN-regulated DEGs (e.g., "53/2481" means 53 out of 2,481 total DEGs).' },
                            { col: 'BgRatio (Background Ratio)', desc: `The baseline fraction of background genes annotated to a specific pathway displayed in an "A/B" format, where “A” is the number of background genes involved in the pathway and “B” is the total genes in the background list from DEG result file (${jobName}_DEG_results.tsv).` },
                            { col: 'RichFactor', desc: 'The degree of pathway enrichment. It indicates what fraction of a pathway was actually altered, calculated by dividing the number of DEGs by the background genes where both involved in a pathway.' },
                            { col: 'FoldEnrich', desc: 'The concentration of the pathway compared to random chance calculated by dividing the GeneRatio by the BgRatio. A higher value means the pathway is strongly and specifically affected in tumor samples.' },
                            { col: 'zScore', desc: 'A statistical metric showing how dramatically gene count deviates from what would be expected in a normal, unperturbed biological background.' },
                            { col: 'pvalue', desc: 'A statistical probability that a pathway appeared in the DEG list by pure chance.' },
                            { col: 'p.adjust', desc: 'A false discovery rate corrected pvalue for more strict standard.' },
                            { col: 'qvalue', desc: 'An alternative statistical metric for false discovery control. While p.adjust controls the error rate across all tests conducted, the qvalue estimates the proportion of false positives specifically among the results that are deemed significant.' },
                            { col: 'geneID', desc: 'The ENSEMBL ID (unique identifier for ENSEMBL database) list of DEGs that are involved in a pathway.' },
                            { col: 'Count', desc: 'The number of DEGs involved in a pathway (this matches the first number in the GeneRatio).' }
                        ].map((item, idx) => (
                            <tr key={idx}>
                                <td style={{ textAlign: 'center', padding: '3px 6px', wordWrap: 'break-word', wordBreak: 'keep-all', whiteSpace: 'normal' }}>
                                    <strong>{item.col}</strong>
                                </td>
                                <td style={{ textAlign: 'left', padding: '3px 6px', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                    {item.desc}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {renderFooter(pageNum_GO_Desc)}
            </div>

            {/* ==========================================
                Page 11: GO Analysis (Biological Process)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`}>
                {renderPageHeader(`${secGO}. Functional Enrichment Analysis (GO)`)}

                <h3 style={s_paraTitle}>Biological Process (BP)</h3>

                <h4 style={s_subTitle}>Up-regulated Genes</h4>
                <div style={{ width: '100%', height: '350px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box', marginBottom: '20px' }}>
                    {images.GO_BP_UP ? (
                        <img src={images.GO_BP_UP} alt="GO BP UP" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[GO BP UP Image Not Found]</span>
                    )}
                </div>

                <h4 style={s_subTitle}>Down-regulated Genes</h4>
                <div style={{ width: '100%', height: '350px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box' }}>
                    {images.GO_BP_DOWN ? (
                        <img src={images.GO_BP_DOWN} alt="GO BP DOWN" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[GO BP DOWN Image Not Found]</span>
                    )}
                </div>

                {renderFooter(pageNum_GO_BP)}
            </div>

            {/* ==========================================
                Page 12: GO Analysis (Molecular Function)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`}>
                {renderPageHeader(`${secGO}. Functional Enrichment Analysis (GO)`)}

                <h3 style={s_paraTitle}>Molecular Function (MF)</h3>

                <h4 style={s_subTitle}>Up-regulated Genes</h4>
                <div style={{ width: '100%', height: '350px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box', marginBottom: '20px' }}>
                    {images.GO_MF_UP ? (
                        <img src={images.GO_MF_UP} alt="GO MF UP" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[GO MF UP Image Not Found]</span>
                    )}
                </div>

                <h4 style={s_subTitle}>Down-regulated Genes</h4>
                <div style={{ width: '100%', height: '350px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box' }}>
                    {images.GO_MF_DOWN ? (
                        <img src={images.GO_MF_DOWN} alt="GO MF DOWN" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[GO MF DOWN Image Not Found]</span>
                    )}
                </div>

                {renderFooter(pageNum_GO_MF)}
            </div>

            {/* ==========================================
                Page 13: GO Analysis (Cellular Component)
            ========================================== */}
            <div className={`pdf-page ${styles.a4Page}`}>
                {renderPageHeader(`${secGO}. Functional Enrichment Analysis (GO)`)}

                <h3 style={s_paraTitle}>Cellular Component (CC)</h3>

                <h4 style={s_subTitle}>Up-regulated Genes</h4>
                <div style={{ width: '100%', height: '350px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box', marginBottom: '20px' }}>
                    {images.GO_CC_UP ? (
                        <img src={images.GO_CC_UP} alt="GO CC UP" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[GO CC UP Image Not Found]</span>
                    )}
                </div>

                <h4 style={s_subTitle}>Down-regulated Genes</h4>
                <div style={{ width: '100%', height: '350px', backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '10px', boxSizing: 'border-box' }}>
                    {images.GO_CC_DOWN ? (
                        <img src={images.GO_CC_DOWN} alt="GO CC DOWN" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    ) : (
                        <span style={{ color: '#ef4444', fontWeight: 'bold' }}>[GO CC DOWN Image Not Found]</span>
                    )}
                </div>

                {renderFooter(pageNum_GO_CC)}
            </div>

        </div> // end of PDF
    );
}

export default DEGInnerReportComponent;